import { Box, FormErrorMessage, Text } from '@chakra-ui/core'
import { StyledFormControl, StyledFormLabel } from 'components/AdminConsole/commonUI/styles'
import OptimizedGroupsTree from 'components/CommonComponents/OptimizedGroupsTree'
import { SelectionMode } from 'components/CommonComponents/OptimizedGroupsTree/hooks/useSelection'
import { PreviewAvatarsList } from 'components/CommonComponents/PreviewList'
import useLocaleText from 'components/useLocaleText'
import { RootState } from 'constants/interfaces'
import { FolderRoot, Users } from 'lucide-react'
import React, { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useSelector } from 'react-redux'

const listHeight = 500

export const RootGroup = () => {
  const { control, errors, getValues, setValue, clearError } = useFormContext()
  const { groups } = useSelector((state: RootState) => state.config.config)
  const t_group = useLocaleText('selected_group', true)
  const t_root_group = useLocaleText('root_group', true)
  const error_root_group = useLocaleText('error_root_group', true)
  const rootGroupId = getValues('root_group_id')

  const rootGroup = useMemo(() => {
    return [rootGroupId].map((id: string) => groups[id])
  }, [groups, rootGroupId])

  const handleGroupsSelectionChange = (ids: string[]) => {
    setValue('root_group_id', ids[0], true)
    clearError('root_group_id')
  }

  const validateAudience = () => {
    const rootGroupId = (getValues('root_group_id') as string) || ''

    if (!rootGroupId) {
      return error_root_group
    }

    return true
  }

  return (
    <StyledFormControl>
      <StyledFormLabel required mt={4}>
        <FolderRoot size={18} strokeWidth={2.5} />
        <Text>{t_root_group}</Text>
      </StyledFormLabel>
      <StyledFormControl mb={2}>
        <PreviewAvatarsList
          icon={Users}
          label={t_group}
          items={
            rootGroupId
              ? rootGroup.map((group) => ({
                  name: group?.name || '',
                }))
              : []
          }
          defaultValue="-"
          max={10}
          isGroup
        />
      </StyledFormControl>

      <Box
        borderRadius="5px"
        bg="white"
        padding={{ base: '0px', md: '10px' }}
        border={errors.root_group_id ? '1px solid red' : '1px solid #e0e0e0'}
        boxShadow={errors.root_group_id ? '0px 0px 0px 1px red' : 'none'}
      >
        <Controller
          control={control}
          name="root_group_id"
          defaultValue={rootGroupId}
          rules={{
            validate: validateAudience,
          }}
          as={
            <OptimizedGroupsTree
              groups={groups}
              allowedGroups={Object.keys(groups)}
              showSearch
              listHeight={listHeight}
              initialSelectedIds={[rootGroupId]}
              onSelectionChange={handleGroupsSelectionChange}
              selectionMode={SelectionMode.SINGLE}
            />
          }
        />
      </Box>

      <StyledFormControl isInvalid={!!errors.root_group_id}>
        <FormErrorMessage>{errors.root_group_id?.message}</FormErrorMessage>
      </StyledFormControl>
    </StyledFormControl>
  )
}
